import * as React from "react"
import anime from "animejs/lib/anime.es.js";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

export const Fish = () => {
    const refFish = React.useRef<any>(null)

    const animateFishes = () => {

        const getRandomArbitrary = (min: number, max: number, mult: number = 10) => {
            let mainNumber = Math.floor(Math.random() * (max - min)) + min;
            return mainNumber * mult
        }

        const setFishes = (bubbles: number): void => {
            let fishBubbles = refFish.current.querySelector(`.af-bg__bubbles-item:nth-child(${bubbles})`)

            anime({
                targets: refFish.current,
                translateX: '-130vw',
                translateY: [`${getRandomArbitrary(1, 5)}vh`, getRandomArbitrary(-15, 15, 1)],
                loop: true,
                easing: 'linear',
                duration: getRandomArbitrary(15, 25, 1000),
                delay: getRandomArbitrary(1, 3, 1000)
            });

            anime({
                targets: fishBubbles,
                translateX: getRandomArbitrary(-100, 100, 1),
                translateY: '-40vh',
                loop: true,
                easing: 'linear',
                scale: 0,
                duration: getRandomArbitrary(5, 25, 1000),
            });
        }

        for (let i = 1; i <= 8; i++) {
            setFishes(i)
        }
    }

    React.useEffect(() => {
        animateFishes()
    }, []);

    return (
        <div className='af-bg__fish' ref={refFish}>
            <img src={`/${THEMEURL}/sources/dist/assets/images/general/background/agua/fish.gif`} alt="" title="" />
            <ul className='af-bg__bubbles'>
                <li className='af-bg__bubbles-item'></li>
                <li className='af-bg__bubbles-item'></li>
                <li className='af-bg__bubbles-item'></li>
                <li className='af-bg__bubbles-item'></li>
                <li className='af-bg__bubbles-item'></li>
                <li className='af-bg__bubbles-item'></li>
                <li className='af-bg__bubbles-item'></li>
                <li className='af-bg__bubbles-item'></li>
            </ul>
        </div>
    )
}

export const FishSec = () => {
    const refFish = React.useRef<any>(null)

    const animateFishes = () => {

        const getRandomArbitrary = (min: number, max: number, mult: number = 10) => {
            let mainNumber = Math.floor(Math.random() * (max - min)) + min;
            return mainNumber * mult
        }

        anime({
            targets: refFish.current,
            translateX: '-130vw',
            translateY: '-15vw',
            loop: true,
            easing: 'linear',
            duration: 20000,
            delay: getRandomArbitrary(1, 3, 1000)
        });
    }

    React.useEffect(() => {
        animateFishes()
    }, []);

    return (
        <div className='af-bg__fish-sec' ref={refFish}>
            <img src={`/${THEMEURL}/sources/dist/assets/images/general/background/agua/fish2.gif`} alt="" title="" />
        </div>
    )
}

export const Bird = () => {
    const animateBird = (): void => {
        anime({
            targets: '.af-bg__bird',
            translateX: '120vw',
            translateY: '-10vw',
            loop: true,
            easing: 'linear',
            duration: 6000,
            delay: 4000,
            endDelay: 6000,
        });
    }

    React.useEffect(() => {
        animateBird()
    }, []);

    return <img className='af-bg__bird' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/bird.gif`} alt="" title="" />
}